import * as React from 'react';
import { View } from 'react-native';
import Picker from 'react-month-picker';

export default function Monthpicker({ show, years, ...props }) {
	if (!years) return;
	const start = years[0] && years[0].accountingStartDate;
	const end = years[years.length - 1].accountingEndDate;
	const [ref, setRef] = React.useState();
	if (ref) ref.show();

	const maxMin = {
		min: { year: parseInt(start.split('-')[0]), month: parseInt(start.split('-')[1]) },
		max: { year: parseInt(end.split('-')[0]), month: parseInt(end.split('-')[1]) }
	};
	//console.log(maxMin);
	return (
		<View style={{ width: 370 }}>
			<Picker lang={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']} {...props} ref={r => setRef(r)} years={maxMin} />
		</View>
	);
}
